<script setup lang="ts">
const props = defineProps<{
  updateType: 'price' | 'factor' | 'both';
  percentageIncrease: number;
  factorIncrease: number;
}>();

const emit = defineEmits<{
  'update:updateType': ['price' | 'factor' | 'both'];
  'update:percentageIncrease': [number];
  'update:factorIncrease': [number];
}>();
</script>

<template>
  <div class="space-y-4">
    <div>
      <label class="block text-sm font-medium text-slate-700 mb-2">Tipo de Actualización</label>
      <div class="space-y-2">
        <label class="flex items-center">
          <input
            type="radio"
            :checked="props.updateType === 'price'"
            @change="emit('update:updateType', 'price')"
            class="text-indigo-600 focus:ring-indigo-500"
          />
          <span class="ml-2 text-sm text-slate-700">Solo Precios</span>
        </label>
        <label class="flex items-center">
          <input
            type="radio"
            :checked="props.updateType === 'factor'"
            @change="emit('update:updateType', 'factor')"
            class="text-indigo-600 focus:ring-indigo-500"
          />
          <span class="ml-2 text-sm text-slate-700">Solo Factores</span>
        </label>
        <label class="flex items-center">
          <input
            type="radio"
            :checked="props.updateType === 'both'"
            @change="emit('update:updateType', 'both')"
            class="text-indigo-600 focus:ring-indigo-500"
          />
          <span class="ml-2 text-sm text-slate-700">Ambos</span>
        </label>
      </div>
    </div>

    <div v-if="props.updateType === 'price' || props.updateType === 'both'">
      <label class="block text-sm font-medium text-slate-700 mb-2">
        Porcentaje de Incremento en Precios
      </label>
      <div class="relative">
        <input 
          type="number" 
          :value="props.percentageIncrease" 
          @input="e => emit('update:percentageIncrease', +(e.target as HTMLInputElement).value)"
          class="input-field pr-8" 
          step="0.1" 
          placeholder="Ej: 10 para 10% de incremento"
        />
        <span class="absolute right-3 top-2 text-slate-500">%</span>
      </div>
    </div>

    <div v-if="props.updateType === 'factor' || props.updateType === 'both'">
      <label class="block text-sm font-medium text-slate-700 mb-2">
        Porcentaje de Incremento en Factores
      </label>
      <div class="relative">
        <input 
          type="number" 
          :value="props.factorIncrease" 
          @input="e => emit('update:factorIncrease', +(e.target as HTMLInputElement).value)"
          class="input-field pr-8" 
          step="0.1" 
          placeholder="Ej: 10 para 10% de incremento"
        />
        <span class="absolute right-3 top-2 text-slate-500">%</span>
      </div>
    </div>
  </div>
</template>